import { Component } from '@angular/core';
import { NavParams, ViewController, AlertController } from 'ionic-angular';

import { AlertService } from '../../../providers/alert-service';
import { PessoalService } from '../../../providers/pessoal-service';
import { FileService } from '../../../providers/file-service';

/*
  Generated class for the ModalListaEvidencia page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-pessoal-evidencia',
  templateUrl: 'modal-pessoal-evidencia.html',
  providers: [
    PessoalService
  ]
})
export class ModalPessoalEvidenciasPage {
  objeto: any;
  titulo: any;
  questaoId: any;
  isJurisdicionado: any;
  cdModulo: any;
  loading: boolean = true;

  constructor(public alertCtrl: AlertController, private fileService: FileService, private alertService: AlertService, private viewCtrl: ViewController, public navParams: NavParams, public pessoalService: PessoalService) {
    this.titulo = this.navParams.get('param1');
    this.objeto = this.navParams.get('objeto');
    this.isJurisdicionado = this.navParams.get('jurisdicionado');

    this.cdModulo = 11;

    this.loading = false;
  }

  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Confirmar']
    });
    alert.present();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  fileChange(event, cdArquivo) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {

        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
          let file: File = fileList[0];

          if (file.size <= 10485760) {
            this.loading = true;
            this.fileService.enviarArquivo(event, this.objeto.idReferenciaContratosTerceirizacao, this.cdModulo, cdArquivo).subscribe(data => {
              this.objeto.arquivos.push(data);
              this.alertService.mostraAlerta("", "Arquivo importado com sucesso!");
            }, error => {
              this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error);
              console.log("erro: " + error);
            });
          } else {
            this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
          }
        }

        this.loading = false;

      }
    });
  }

  deletarArquivo(arquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + arquivo.nmArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.loading = true;
          this.fileService.deletarArquivo(arquivo.idArquivoVinculado).subscribe(data => {

            var i = this.objeto.arquivos.indexOf(arquivo);
            if (i != -1) {
              this.objeto.arquivos.splice(i, 1);
            }

            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
          }, error => {
            console.log("erro: " + error);
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });

          this.loading = false;
        }
      }
    );
  }

  // baixarArquivo(urlArquivo) {    
  //   this.pessoalService.downloadArquivoPessoal(urlArquivo);
  // }

  baixarArquivo(idArquivoVinculado) {
    this.loading = true;
    this.fileService.downloadArquivo(idArquivoVinculado);
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pessoal-evidencia/modal-pessoal-evidencia.ts